exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".DQgZJyuKPoXmGjyca-MP9 .ms-TextField-fieldGroup{min-height:20px!important}html[dir] .DQgZJyuKPoXmGjyca-MP9 .ms-TextField-fieldGroup{background-color:transparent}.DQgZJyuKPoXmGjyca-MP9 .ms-TextField-field{overflow:hidden;line-height:20px}html[dir] .DQgZJyuKPoXmGjyca-MP9 .ms-TextField-field{padding:0}.QfIHnh5TOQEP9bqLLiNR{line-height:20px;-webkit-appearance:menulist-textfield;-moz-appearance:textfield}html[dir] .QfIHnh5TOQEP9bqLLiNR{padding:0}._1o-z8UfSlU5SzLWvF6kXK0{word-wrap:break-word;word-break:break-word;white-space:pre-wrap}", ""]);

// exports
exports.locals = {
	"editableTitle": "DQgZJyuKPoXmGjyca-MP9",
	"displayTitle": "QfIHnh5TOQEP9bqLLiNR",
	"titleWrapper": "_1o-z8UfSlU5SzLWvF6kXK0"
};